import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Product } from 'data/terra/Product';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { ProductSelectorState } from '../reducer';

export const PAGE_SIZE = 200;

enum ActionTypes {
  loadInit = 'products/loadInit',
  loadInitSuccess = 'products/loadInitSuccess',
  loadInitFailure = 'products/loadInitFailure',
}

export interface FetchProductsAction {
  type: ActionTypes;
  products: Product[];
  error?: string;
}

export const fetchProducts = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  dispatch({ type: ActionTypes.loadInit });
  const result = await Terra.product.fetchProducts({
    page: 1,
    pageSize: PAGE_SIZE,
  });
  if (result.isSuccess()) {
    dispatch({
      type: ActionTypes.loadInitSuccess,
      products: result.get()!.data,
    } as FetchProductsAction);
  } else {
    dispatch({
      type: ActionTypes.loadInitFailure,
      error: result.exception().message,
    } as FetchProductsAction);
  }

  return result;
};

export const fetchProductsDelegate: DelegateMapEntry<
  FetchProductsAction,
  ProductSelectorState
> = {
  [ActionTypes.loadInit]: (
    state: ProductSelectorState,
    action: FetchProductsAction
  ): ProductSelectorState => {
    return {
      ...state,
      products: [],
      hasInitialized: false,
      currentPage: 0,
      isLoadingInit: true,
      hasMore: true,
      isLoadingMore: false,
      productError: undefined,
    };
  },
  [ActionTypes.loadInitSuccess]: (
    state: ProductSelectorState,
    action: FetchProductsAction
  ): ProductSelectorState => {
    return {
      ...state,
      products: action.products,
      hasInitialized: true,
      hasMore: action.products.length === PAGE_SIZE,
      currentPage: 1,
      isLoadingInit: false,
    };
  },
  [ActionTypes.loadInitFailure]: (
    state: ProductSelectorState,
    action: FetchProductsAction
  ): ProductSelectorState => {
    return {
      ...state,
      isLoadingInit: false,
      productError: action.error,
    };
  },
};
